module.exports = __webpack_public_path__ + "img/atlantic-city.3f3047ef.webp";